import React from 'react';
import { useNavigate } from 'react-router';

import { SkinImage } from '@app/dev/terminal/components/skinImage';
import Video from '@app/dev/images/favoriteCompetitions/home-banner-2-betone.mp4';
import LasvegasVideo from '@app/dev/images/favoriteCompetitions/home-banner-1-dmslasvegas.mp4';
import PropTypes from 'prop-types';

export const BannerItem = ({ path, index = 1, fileType }) => {
  const navigate = useNavigate();

  const isExternal = path?.startsWith('http');

  const onNavigate = () => {
    if (isExternal) {
      window.open(path, '_self');
    } else {
      navigate(path);
    }
  };

  if (fileType === 'video') {
    return (
      <video className="home-banner video" autoPlay loop onClick={onNavigate}>
        <source src={SKIN_SHORT_NAME === 'dmslasvegas' ? LasvegasVideo : Video} type="video/mp4" />
      </video>
    );
  }

  return (
    <SkinImage
      className="home-banner"
      fileType={fileType}
      onClick={onNavigate}
      path={`favoriteCompetitions/home-banner-${index}.${fileType || 'jpeg'}`}
    />
  );
};

BannerItem.propTypes = {
  path: PropTypes.string,
  index: PropTypes.number,
  fileType: PropTypes.string,
};
